/**
 * Field mappings for uploaded PDF forms (Filer).
 *
 * Each mapping lives in `file.files[].pdfFields` as `[type, name, mapTo]`. A mapTo of
 * `animal.chipId` writes the value into the PDF text field as text; `qr:animal.chipId`
 * draws it as a QR code over that field instead. Keep the prefix in sync with
 * backend/lib/pdf-qr-fields.js, which reads it when the PDF is prefilled.
 */
export const QR_PREFIX = 'qr:';

/** True when this mapping should be rendered as a QR code instead of text. */
export function isQrMapping(mapTo) {
    return typeof mapTo === 'string' && mapTo.startsWith(QR_PREFIX);
}

/** The plain field key behind a mapping, so the select can show what it points at. */
export function stripQrPrefix(mapTo) {
    if (!mapTo) {
        return '';
    }
    return isQrMapping(mapTo) ? mapTo.slice(QR_PREFIX.length) : mapTo;
}

/** Store `key` with or without the QR prefix. An unmapped field stays empty. */
export function withQrPrefix(mapTo, enabled) {
    const key = stripQrPrefix(mapTo);
    if (!key) {
        return '';
    }
    return enabled ? `${QR_PREFIX}${key}` : key;
}
